const api = require("./api");

export default {

    getUsersList() {
        return api(
            {
                url: "/api_v2/user",
                method: "get",
                headers: {
                    "X-TOKEN": localStorage.getItem("token") || "",
                    "X-LOGIN": localStorage.getItem("login") || ""
                }
            }
        );
    },
    getUser(login) {
        return api(
            {
                url: "/api_v2/user/"+login,
                method: "get",
                headers: {
                    "X-TOKEN": localStorage.getItem("token") || "",
                    "X-LOGIN": localStorage.getItem("login") || ""
                }
            }
        );
    },
    deleteUser(id) {
        return api(
            {
                url: "/api_v2/user/"+id,
                method: "delete",
                headers: {
                    "X-TOKEN": localStorage.getItem("token") || "",
                    "X-LOGIN": localStorage.getItem("login") || ""
                }
            }
        );
    },
    createUser(user) {
        return api(
            {
                url: "/api_v2/user/",
                method: "post",
                headers: {
                    "X-TOKEN": localStorage.getItem("token") || "",
                    "X-LOGIN": localStorage.getItem("login") || ""
                },
                data: user
            }
        );
    },
    updateUser(user) {
        return api(
            {
                url: "/api_v2/user/",
                method: "put",
                headers: {
                    "X-TOKEN": localStorage.getItem("token") || "",
                    "X-LOGIN": localStorage.getItem("login") || ""
                },
                data: user
            }
        );
    }
}